import "bootstrap/dist/css/bootstrap.min.css";
import "../../src/style/story.css"; 

// ✅ Reusable StoryCard component
const StoryCard = ({ title, text, link, imgSrc }) => (
  <div className="col-md-6 col-lg-4 mb-4">
    <div className="card story-card h-100 border-0 shadow-sm rounded-4 overflow-hidden">
      <div className="row g-0 h-100">
        <div className="col-12 col-sm-6 d-flex flex-column justify-content-center p-4">
          <h5 className="fw-bold">{title}</h5>
          {text && <p className="text-muted mb-3">{text}</p>}
          <a href={link} className="read-link text-decoration-none fw-semibold">
            Continue reading →
          </a>
        </div>
        <div className="col-12 col-sm-6">
          <img src={imgSrc} alt={title} className="img-fluid story-img w-100 h-100 object-fit-cover" />
        </div>
      </div>
    </div>
  </div>
);

export default StoryCard;


